// extracted by mini-css-extract-plugin
export var label = "_gj-2";
export var slideContainer = "_gj-0";
export var slider = "_gj-1";